import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { SharedModule } from '@app/shared/shared.module';
import { UserProfileComponent } from './user-profile.component';
import { RouterModule } from '@angular/router';
import { ChangePasswordComponent } from '../change-password/change-password.component';
import { FuseAlertComponent } from '@fuse/components/alert';
import { ScreenSaverPinDialogComponent } from './screen-saver-pin-dialog/screen-saver-pin-dialog.component';

@NgModule({
    declarations: [UserProfileComponent, ChangePasswordComponent, ScreenSaverPinDialogComponent],
    imports: [

        RouterModule,

        CommonModule,
        MatButtonModule,
        MatDividerModule,
        MatIconModule,
        MatMenuModule,

        FuseAlertComponent,

        SharedModule
    ],
    exports: [UserProfileComponent, ScreenSaverPinDialogComponent]
})
export class UserProfileModule { }
